import css from 'styled-jsx/css';
import { colors } from '../../themes';

export default css`
  .breadcrumb {
    border-bottom: 1px solid ${colors.grayExtraLight};
    position: relative;
    z-index: 1;
  }

  .breadcrumb :global(ol) {
    font-size: 0.75em; /* 12/16 */
    margin: 0;
    overflow: auto;
    padding: 5px 2px 7px;
    white-space: nowrap;
  }

  .breadcrumb :global(li) {
    display: inline-block;
    padding: 5px 15px 5px 10px;
    position: relative;
  }

  .breadcrumb :global(strong) {
    font-weight: normal;
  }

  .breadcrumb :global(a::after) {
    content: '\\203A';
    color: ${colors.gray};
    position: absolute;
    right: 0;
  }

  :global(.rtl) .breadcrumb :global(li) {
    padding: 5px 10px 5px 15px;
  }

  :global(.rtl) .breadcrumb :global(a::after) {
    content: '\\203A';
    left: 0;
    right: auto;
  }

  .breadcrumb :global(li:last-child a::after) {
    content: '';
  }

  .gradient {
    background: linear-gradient(to right, rgba(255, 255, 255, 0.001) 0%, #fff 100%);
    height: 31px;
    position: absolute;
    top: 0;
    right: 0;
    width: 25px;
  }

  :global(.rtl) .gradient {
    left: 0;
    right: auto;
    width: 25px;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Breadcrumb/styles.js